"use client";

import { menu_define, filterMenuByFeatures } from '@/core/constants/menu-define'
import MenuItem from './item'
import { useTranslation } from 'react-i18next';
import SidebarSettings from '../settings';
import { usePlatformSettingsStore, selectFeatures } from '@/store/platform-settings/store';
import { useMemo } from 'react';

export default function SideBarMenu() {
  const { t } = useTranslation();
  const features = usePlatformSettingsStore(selectFeatures);

  const menuItems = menu_define(t);
  const logoutItem = menuItems[menuItems.length - 1];
  const mainItems = useMemo(() => {
    return filterMenuByFeatures(menuItems.slice(0, -1), features);
  }, [t, features]);

  return (
    <>
      {mainItems &&
        mainItems.length > 0 &&
        mainItems.map((item, index) => (
          <MenuItem key={index} item={item} />
        ))}

      {/* Bottom section: icônes langue/thème + logout + version */}
      <div className="sidebar-bottom">
        <SidebarSettings />
        {logoutItem && <MenuItem item={logoutItem} />}
      </div>
    </>
  )
}
